import React from 'react';
import './FeatureGate.css';

/**
 * Компонент для отображения недоступной функции
 * 
 * Использование:
 * <FeatureGate 
 *   hasAccess={canUseStorage} 
 *   featureName="Хранилище файлов"
 *   requiredPlan="Pro"
 * >
 *   <FileManager />
 * </FeatureGate>
 */
const FeatureGate = ({
    hasAccess,
    children,
    featureName = 'Эта функция',
    requiredPlan = 'Pro',
    showOverlay = false,  // показать контент затемнённым
    onUpgradeClick = null,
}) => {
    if (hasAccess) {
        return <>{children}</>;
    }

    if (showOverlay) {
        return (
            <div className="feature-gate-overlay-container">
                <div className="feature-gate-overlay">
                    <div className="feature-gate-overlay-content">
                        {children}
                    </div>
                    <div className="feature-gate-overlay-blur">
                        <div className="feature-gate-message">
                            <h3>{featureName}</h3>
                            <p>Доступно на тарифе <strong>{requiredPlan}</strong></p>
                            {onUpgradeClick && (
                                <button
                                    className="feature-gate-upgrade-btn"
                                    onClick={onUpgradeClick}
                                >
                                    Улучшить подписку
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="feature-gate-blocked">
            <h3>{featureName}</h3>
            <p>Доступно на тарифе <strong>{requiredPlan}</strong></p>
            {onUpgradeClick && (
                <button
                    className="feature-gate-upgrade-btn"
                    onClick={onUpgradeClick}
                >
                    Улучшить подписку
                </button>
            )}
        </div>
    );
};

export default FeatureGate;
